import profilesActionTypes from "../actions/profilesActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const profilesReducer = reducerFactory.readReducer(
  profilesActionTypes
);
